import {IPolicy, IPolicyCollection} from "../PA.Core.IF.Policy";
import {BehaviorSubject, Subscription} from "rxjs";
import * as _ from 'lodash'


export class PolicyCollection
  implements
    IPolicyCollection
{

  _PolicyChanged: BehaviorSubject<IPolicyCollection>
  _dctSubscriptionsByPolicy: {[id: string] : Subscription}

  constructor(){
    this._dctSubscriptionsByPolicy = {}
    this._PolicyChanged = new BehaviorSubject<IPolicyCollection>(this)
  }

  get PolicyChanged(): BehaviorSubject<IPolicyCollection> {
    return this._PolicyChanged
  }

  addPolicy(name: string, aPolicy: IPolicy): void {
    if(_.isEmpty(name) || _.isEmpty(aPolicy)){ return }
    this.removePolicy(name, true)

    this._dctSubscriptionsByPolicy[name] = aPolicy.PolicyChanged.subscribe(this._evtOnPolicyChanged.bind(this))
    let dctPolicy: any = this
    dctPolicy[name] = aPolicy
    this.PolicyChanged.next(this)
  }


  removePolicy(name: string, bSuppressNotify?: boolean): void {
    if(name in this._dctSubscriptionsByPolicy){
      this._dctSubscriptionsByPolicy[name].unsubscribe()
      delete this._dctSubscriptionsByPolicy[name]
      if(!bSuppressNotify) {
        this.notifyPolicyChanged()
      }
    }

  }

  notifyPolicyChanged(){
    this.PolicyChanged.next(this)
  }

  _evtOnPolicyChanged(aPolicy: IPolicy){
      this.notifyPolicyChanged()
  }


}